import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  type InputProps,
} from '@chakra-ui/react';

import { isValidPostalCode } from '../utils/postalCode';

interface PostalCodeInputProps extends Omit<InputProps, 'onChange'> {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  isRequired?: boolean;
}

const PostalCodeInput = ({
  label = 'Postal Code',
  value,
  onChange,
  isRequired = false,
  isDisabled,
  ...inputProps
}: PostalCodeInputProps) => {
  const hasValue = value && value.trim().length > 0;
  const isInvalid = hasValue && !isValidPostalCode(value);

  return (
    <FormControl
      isRequired={isRequired}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
    >
      <FormLabel fontSize="sm">{label}</FormLabel>
      <Input
        variant="main"
        size="sm"
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        placeholder="A1A 1A1"
        maxLength={7}
        {...inputProps}
      />
      <FormErrorMessage color="red.600">
        Invalid format (e.g., A1A 1A1)
      </FormErrorMessage>
    </FormControl>
  );
};

export default PostalCodeInput;
